module.exports = __webpack_public_path__ + "img/contract.6e5e8a96.png";